import { Box, Grid, Stack, Typography } from "@mui/material";
import React from "react";
import "./cartPackageDetails.scss";
import SubtitleTypography from "../../../typography/SubtitleTypography";
import ImageView from "../../../ImageView/ImageView";
import ShowMoreShowLess from "../../../ShowMoreShowLess/ShowMoreShowLess";
import Carousel from "react-multi-carousel";
import {
  CAROUSEL_REMOVE_ARRAOW_ON_DEVICE,
  orderType,
  PUJA_PACKAGE_SCROLL_RESPONSIVE,
} from "../../../../utils/Constants";
import SingleChadavaPackageItem from "../../../SingleChadavaPackage/SingleChadavaPackageItem";
import {
  getCityStateFromTemple,
  getTempleNameById,
} from "../../../../utils/HelperFunctions";
import SubtitleTypographyPrimary from "../../../typography/SubtitleTypographyPrimary";
import { LOCALIZATION } from "../../../../utils/localization";
import { useTranslation } from "react-i18next";

const CartPackageDetails = (props: any) => {
  const { cartDetails } = props;
  const { t } = useTranslation();
  const packageList = cartDetails?.pujaDetails?.packageItems
    ? Object.values(cartDetails.pujaDetails.packageItems)
    : [];

  const subscriptionId = cartDetails?.subscriptionId;

  const filteredSubscription =
    cartDetails?.pujaDetails?.subscriptions?.find(
      (sub: any) => sub.id === subscriptionId
    ) || null;

  const subscriptionName = filteredSubscription?.name || "";
  const subscriptionFrequency = filteredSubscription?.frequency || "";
  const subscriptionType = filteredSubscription?.type || "";

  return (
    <Box className="packageMainCard">
      <SubtitleTypography
        className="topTitle"
        title={t(LOCALIZATION.Review_Package_Details)}
      />
      <Box className="cardDesign pujaInformation">
        <Stack
          className="pujaInfoTop"
          direction="row"
          justifyContent="space-between"
          alignItems="center"
          spacing={2}
        >
          <Box className="pujaDetailsLeft">
            <Typography className="pujaName">
              {cartDetails?.pujaDetails?.pujaName}
            </Typography>

            <Box className="pillSection">
              {!cartDetails?.isSubscribed &&<Box className="pill package">
                {cartDetails?.orderType === orderType.pujaPackage
                  ? t("Puja_Package")
                  : cartDetails?.orderType === orderType.chadhavaPackage
                  ? t("Chadhava_Package")
                  : "Package"}
              </Box>}
              {cartDetails?.isSubscribed && (
                <Box className="pill subscribed">
                  {t(LOCALIZATION.Subscribed)}
                </Box>
              )}
            </Box>
          </Box>

          <Box className="pujaImage">
            {cartDetails?.pujaDetails?.pujaBg?.uri && (
              <ImageView
                src={cartDetails.pujaDetails.pujaBg.uri}
                alt="puja Image"
                height={60}
                width={60}
                sizes="(max-width: 768px) 60px, 60px"
              />
            )}
          </Box>
        </Stack>

        <Box>
          {cartDetails?.isSubscribed ? (
            <Box className="bottomDescription">
              <Typography variant="h6" className="monthlyPlanreview">
                {subscriptionName} ({subscriptionFrequency} {subscriptionType})
              </Typography>
              <ShowMoreShowLess
                text={
                  cartDetails?.pujaDetails?.subscriptions?.[0]?.description ||
                  ""
                }
                limit={120}
              />
            </Box>
          ) : (
            <Box className="bottomDescription">
              <ShowMoreShowLess
                text={cartDetails?.pujaDetails?.packageDescription || ""}
                limit={120}
              />
            </Box>
          )}
        </Box>

        <Box className="packageoverViewText" id="puja-overview" sx={{ mb: 2 }}>
          <SubtitleTypographyPrimary
            title={
              cartDetails?.orderType === orderType.pujaPackage
                ? t("Item_Included_In_This_Puja_Package")
                : cartDetails?.orderType === orderType.chadhavaPackage
                ? t("Item_Included_In_This_Chadhava_Package")
                : "Item Included In This Package"
            }
          />
        </Box>
        <Box className="productCardCarousel">
          {packageList.length > 0 && (
            <Carousel
              responsive={PUJA_PACKAGE_SCROLL_RESPONSIVE}
              swipeable
              draggable
              showDots
              infinite
              keyBoardControl
              containerClass="carousel-container"
              itemClass="carousel-item-padding-40"
              removeArrowOnDeviceType={CAROUSEL_REMOVE_ARRAOW_ON_DEVICE}
            >
              {packageList.map((pkg: any) => {
                let imageUrl =
                  pkg.multiPujaImg?.[1]?.pictureUrl ?? pkg.pujaBg?.uri;
                if (cartDetails?.orderType === orderType.chadhavaPackage) {
                  imageUrl = pkg?.image;
                }

                const templeName = getTempleNameById(
                  cartDetails?.pujaDetails?.templeList,
                  pkg.orgId
                );
                const personalInfo =
                  cartDetails?.pujaDetails?.templeList?.[pkg?.orgId]
                    ?.personalInfo;

                const templeAddress = getCityStateFromTemple(personalInfo);
                return (
                  <div key={pkg.id} style={{ cursor: "pointer" }}>
                    <SingleChadavaPackageItem
                      packageImage={imageUrl}
                      packageName={
                        cartDetails?.orderType === orderType.pujaPackage
                          ? pkg?.pujaName
                          : pkg?.name
                      }
                      templeName={templeName}
                      templeAddress={templeAddress}
                    />
                  </div>
                );
              })}
            </Carousel>
          )}
        </Box>
      </Box>
    </Box>
  );
};

export default CartPackageDetails;
